import { Layout, Menu } from "antd";
import { useState, useEffect } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { getUserMenus } from "@/api/system/user";
import IconFont from "@/components/Icon/IconFont";
import { LeftOutlined, RightOutlined, MenuOutlined } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import { useMediaQuery } from "react-responsive";
import LogoImg from '@/assets/imgs/logo.png'
import { useTranslation } from "react-i18next";

const { Sider } = Layout;
const VerticalCenteredSider = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  let [menuItems, setMenuItems] = useState([]);
  const [collapsed, setCollapsed] = useState(false);

  const themePrimaryColor = useSelector((state) => {
    return state.theme.themePrimaryColor;
  });
  const [levelKeys, setLevelKeys] = useState([]);

  const dispatch = useDispatch();
  // 检测设备类型
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1023 });
  const isDesktop = useMediaQuery({ minWidth: 1024 });

  useEffect(() => {
    getMenus();
  }, []);
  const handleLogoClick = () => {
    navigate("/");
  };

  const getMenus = () => {
    getUserMenus({ id: localStorage.getItem("userId") }).then((res) => {
      let filtedMeuns = res?.data.filter(item => item.visibleFlag === "1")
      dispatch({ type: "setMenus", data: JSON.parse(JSON.stringify(filtedMeuns)) })
      const newMenuItems = menus2Tree(filtedMeuns) || []
      setMenuItems(newMenuItems);
      const levelKeys = getLevelKeys(newMenuItems);
      setLevelKeys(levelKeys)
    });
  };

  const menus2Tree = (menus) => {
    menus = menus.filter(menu => menu.menuType === "1");
    let roots = menus.filter((menu) => menu.parentId === -1);
    if (roots) {
      roots.sort((a, b) => a.menuOrder - b.menuOrder);
    }
    let nodes = [];
    for (let menu of roots) {
      let children = findChildren(menus, menu.id);
      menu.children = children;
      if (menu.children) {
        menu.children.sort((a, b) => a.menuOrder - b.menuOrder);
      }
      menu = convertMenuItem(menu);
      nodes.push(menu);
    }
    return nodes;
  };

  const findChildren = (menus, parentId) => {
    let children = menus.filter((menu) => menu.parentId === parentId);
    let nodes = [];
    for (let menu of children) {
      let children = findChildren(menus, menu.id);
      menu.children = children;
      if (menu.children) {
        menu.children.sort((a, b) => a.menuOrder - b.menuOrder);
      }
      nodes.push(menu);
    }
    if (nodes.length === 0) {
      return null;
    }
    return nodes;
  };

  const convertMenuItem = (menuItem) => {
    return {
      id: menuItem.id,
      key: `menu-${menuItem.id}`, // 保持唯一性
      path: menuItem.url ? menuItem.url.split('?')[0] : menuItem.url, // 基础路径，用于路由匹配
      fullpath: menuItem.url, // 完整URL，包括查询参数
      disabled: menuItem.disableFlag === '1',
      label:
        menuItem.children && menuItem.children.length > 0 ? (
          menuItem.label
        ) : menuItem.externalFlag !== '1' ? (
          <NavLink to={menuItem.url}> {menuItem.label} </NavLink>
        ) : (
          <a href={menuItem.url} target="_blank" rel="noopener noreferrer" style={menuItem.disabled ? { disabled: true } : {}}>
            {menuItem.label}
          </a>
        ),
      icon: <IconFont icon={menuItem.icon || "faQuestion"} />,
      children:
        menuItem.children && menuItem.children.length > 0
          ? menuItem.children.map((child) => convertMenuItem(child))
          : null,
    };
  };

  /**
   * 创建菜单项键(key)和它们在菜单层级结构中对应层级(level)之间的映射关系
   * 用于管理菜单的展开和折叠行为
   */
  const getLevelKeys = items1 => {
    const key = {};
    const func = (items2, level) => {
      items2.forEach(item => {
        if (item.key) {
          key[item.key] = level;
        }
        if (!!item.children) {
          func(item.children, level + 1);
        }
      });
    };
    func(items1, 1);
    return key;
  };

  // 找到当前路径对应的菜单key
  const [menuFullPathKeyMap, setMenuFullPathKeyMap] = useState({})
  useEffect(() => {
    const buildMap = (items) => {
      return items.reduce((acc, item) => {
        acc[item.fullpath] = item.key;
        if (item.children) {
          Object.assign(acc, buildMap(item.children));
        }
        return acc;
      }, {});
    };

    setMenuFullPathKeyMap(buildMap(menuItems));
  }, [menuItems])
  const getCurrentMenuKey = (currentPath, currentSearch) => {
    const fullPath = currentSearch ? `${currentPath}${currentSearch}` : currentPath
    return menuFullPathKeyMap[fullPath] || null
  };

  // 移动端菜单按钮
  const MobileMenuButton = () => (
    <div
      onClick={() => setCollapsed(!collapsed)}
      style={{
        position: "fixed",
        top: 10,
        left: 10,
        width: 40,
        height: 40,
        background: themePrimaryColor,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        zIndex: 1002,
        boxShadow: `0 2px 8px ${themePrimaryColor}66`,
        transition: "all 0.3s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.boxShadow = `0 4px 12px ${themePrimaryColor}99`;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.boxShadow = `0 2px 8px ${themePrimaryColor}66`;
      }}
    >
      <MenuOutlined
        style={{
          fontSize: 18,
          color: "#1677ff",
        }}
      />
    </div>
  );
  // Logo组件
  const Logo = () => (
    <div
      onClick={() => handleLogoClick()}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "16px 0",
        borderBottom: "1px solid #f0f0f0",
        height: "55px",
        transition: "all 0.3s ease",
        cursor: "pointer",
      }}
    >
      {collapsed ? (
        // 收起状态显示小logo
        <div
          style={{
            width: "32px",
            height: "32px",
            backgroundImage: `url(${LogoImg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        />
      ) : (
        // 展开状态显示完整logo
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <div
            style={{
              width: "32px",
              height: "32px",
              backgroundImage: `url(${LogoImg})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              marginRight: "12px",
            }}
          />
          <span
            style={{
              fontSize: "18px",
              fontWeight: "600",
              color: "#666",
              whiteSpace: "nowrap",
            }}
          >
            {t('logoTitle')}
          </span>
        </div>
      )}
    </div>
  );

  // PC端侧边栏
  const DesktopSider = () => {

    const openKeys = useSelector((state) => {
      return state.menu.openKeys
    });
    // 展开折叠行为
    const onOpenChange = changedOpenKeys => {
      const currentOpenKey = changedOpenKeys.find(key => !openKeys.includes(key));
      // 展开操作
      let newOpenKeys = [...changedOpenKeys];
      if (currentOpenKey !== undefined) {
        const repeatIndex = changedOpenKeys
          .filter(key => key !== currentOpenKey)
          .findIndex(key => levelKeys[key] === levelKeys[currentOpenKey]);

        newOpenKeys = changedOpenKeys
          // remove repeat key
          .filter((_, index) => index !== repeatIndex)
          // remove current level all child
          .filter(key => levelKeys[key] <= levelKeys[currentOpenKey])
      }
      dispatch({
        type: "setOpenKeys", data: newOpenKeys
      })
    }

    return (
      <div
        style={{
          position: "relative",
          height: "100%",
          display: "flex",
          alignItems: "center",
          width: collapsed ? "auto" : "230px",
        }}
      >
        <Sider
          theme="light"
          width={isTablet ? 230 : 230}
          collapsedWidth={40}
          collapsible
          collapsed={collapsed}
          onCollapse={(value) => setCollapsed(!value)}
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            overflowY: "auto",
            height: "100vh",
            // borderRadius: "20px",
            position: "sticky",
            insetInlineStart: 0,
            zIndex: 1000,
          }}
          breakpoint="lg"
          trigger={null}
        >
          <Logo />
          <div style={{ flex: 1, overflowY: "auto" }}>
            <Menu
              theme="light"
              mode="inline"
              selectedKeys={[getCurrentMenuKey(location.pathname, location.search)]}
              openKeys={openKeys}
              onOpenChange={onOpenChange}
              items={menuItems}
              style={{
                height: "100%",
                borderRight: 0,
              }}
            />
          </div>
        </Sider>

        {/* 使用纯色背景的圆角矩形展开/收缩按钮 */}
        <div
          onClick={() => setCollapsed(!collapsed)}
          style={{
            position: "relative",
            width: 14,
            height: 70,
            background: "linear-gradient(#1677ff, #4096ff)",
            borderRadius: "0 8px 8px 0",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            zIndex: 1001,
            transition: "all 0.3s ease",
            border: "1px solid #1677ff",
            borderLeft: "none",
            boxShadow: "2px 0 8px rgba(50, 30, 233, 0.4)",
            opacity: 0.9,
          }}
          onMouseEnter={(e) => {
            // 悬停时增加不透明度
            e.currentTarget.style.opacity = "1";
            e.currentTarget.style.boxShadow = "2px 0 12px rgba(30, 67, 233, 0.6)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.opacity = "0.9";
            e.currentTarget.style.boxShadow = "2px 0 8px rgba(30, 44, 233, 0.4)";
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            {collapsed ? (
              <RightOutlined
                style={{
                  fontSize: 16,
                  color: "#ffffff",
                  filter: "drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.3))",
                }}
              />
            ) : (
              <LeftOutlined
                style={{
                  fontSize: 16,
                  color: "#ffffff",
                  filter: "drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.3))",
                }}
              />
            )}
          </div>
        </div>
      </div>
    )
  }
  // 移动端侧边栏抽屉
  const MobileSider = () => (
    <>
      <MobileMenuButton />
      {collapsed && (
        <div
          onClick={() => setCollapsed(!collapsed)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1001,
          }}
        />
      )}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: collapsed ? 0 : -250,
          width: 225,
          height: "100vh",
          background: "#fff",
          zIndex: 1002,
          transition: "left 0.3s ease",
          boxShadow: "2px 0 8px rgba(0, 0, 0, 0.15)",
          // borderRadius: "10px",
          overflowY: "scroll",
        }}
      >
        <Sider
          theme="light"
          width={225}
          style={{
            height: "100%",
            borderRadius: "10px",
          }}
        >
          <Menu
            theme="light"
            mode="inline"
            items={menuItems}
            style={{
              height: "100%",
              borderRight: 0,
              marginTop: 50,
            }}
          />
        </Sider>
      </div>
    </>
  );

  return (
    <>
      {/* PC端和平板端显示桌面版侧边栏 */}
      {isDesktop || isTablet ? <DesktopSider /> : null}

      {/* 移动端显示移动版侧边栏 */}
      {isMobile ? <MobileSider /> : null}
    </>
  );
};

export default VerticalCenteredSider;
